import React, { useState, useEffect } from "react";
import ChartSelector from "./ChartSelector1";
import ChartDisplay from "./ChartDisplay";
import DownloadOptions from "./DownloadOptions";

const Dashboard = ({ data, handleRefresh }) => {
  const [selectedChartType, setSelectedChartType] = useState("donut");
  const [chartKey, setChartKey] = useState(0);
  const chartId = "program-summary-chart";

  useEffect(() => {
    setChartKey((prevKey) => prevKey + 1);
  }, [selectedChartType]);

  const chartTypes = [
    { value: "donut", label: "Donut Chart" },
    { value: "pie", label: "Pie Chart" },
    { value: "radar", label: "Radar Chart" },
    // { value: "bar", label: "Bar Chart" },
  ];

  return (
    <div>
      {/* Top Controls */}
      <div className="d-flex justify-between items-center mb-2">
        <ChartSelector
          chartTypes={chartTypes}
          selectedChartType={selectedChartType}
          onSelectChart={setSelectedChartType}
        />
        <DownloadOptions chartId={chartId} handleRefresh={handleRefresh} />
      </div>

      {/* Chart Display */}
      <div id="program-stats-chart">
        <ChartDisplay
          key={chartKey}
          data={data}
          chartType={selectedChartType}
          chartId={chartId}
        />
      </div>
    </div>
  );
};

export default Dashboard;
